import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IAnnualResultProps } from "../types";

export const AnnualResultOverview = ({ isDefaultLanguage, managmentFee, depotFee, summedFee }: IAnnualResultProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex w-full p-2 border rounded-md bg-white">
      <div className="flex w-full">
        <div className="flex flex-col w-full">
          <Typography variant={"Bold"}>{texts.PAGE_15_ANNUAL}</Typography>
          <Typography variant={"Body"}>{texts.PAGE_15_COMMISIONER}</Typography>
          <Typography variant={"Body"}>{texts.PAGE_15_TRANSACTION_COST}</Typography>
          <Typography variant={"Body"}>{texts.PAGE_15_COST_BANK}</Typography>
          <Typography variant={"Body"}>{texts.PAGE_15_TOTAL}</Typography>
        </div>

        <div className="flex flex-col items-end">
          <Typography variant={"Bold"}>{texts.PAGE_15_PERCENTAGE}</Typography>
          <Typography variant={"Body"}>{managmentFee?.toFixed(2)}%</Typography>
          <Typography variant={"Body"}>{0}%</Typography>
          <Typography variant={"Body"}>{depotFee?.toFixed(2)}%</Typography>
          <Typography variant={"Body"}>{summedFee?.toFixed(2)}%</Typography>
        </div>
      </div>
    </div>
  );
};
